export default class VerifyEmailUniquenessDto {
	public email = '';
}